import { PermissionGuard } from '@/auth/guard';
import { OrionAccess, OrionModule, OrionSubmodule } from '@/types';
import { ContactListPage, ContactEditPage, ContactCreatePage } from './imports';

export const contactRoutes = [
  {
    path: 'contacts',
    children: [
      {
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.CONTACT}
            access={OrionAccess.VIEW}
          >
            <ContactListPage />
          </PermissionGuard>
        ),
        index: true,
      },
      {
        path: 'list',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.CONTACT}
            access={OrionAccess.VIEW}
          >
            <ContactListPage />
          </PermissionGuard>
        ),
      },
      {
        path: 'new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.CONTACT}
            access={OrionAccess.CREATE}
          >
            <ContactCreatePage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.CONTACT}
            access={OrionAccess.UPDATE}
          >
            <ContactEditPage />
          </PermissionGuard>
        ),
      },
    ],
  },
];
